import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ACCOUNT_RECOVERY_ERROR, REMAINING_ATTEMPT } from '../../../constants';
import {
  AddMfaBackup,
  Authenticate,
  CancelAuthentication,
  CancelPairing,
  CheckNewPassword,
  ContinueAuthentication,
  FlyDeltaPoll,
  InitiateAccountRecovery,
  InitiateAuthentication,
  InitiatePasswordChange,
  InitiateSsoSession,
  InitiateUserRegistration,
  OauthAEMConfig,
  SelectDevice,
  SubmitEmailOtp,
  SubmitEmailResponse,
  SubmitFlyDeltaMethod,
  SubmitNewPassword,
  SubmitSkymilesNumber,
  SubmitSmsNumber,
  SubmitSmsOtp,
  SubmitUserRegistration
} from '../../../models';
@Injectable({
  providedIn: 'root'
})
export class MfaUtilHelperService {
  errorCode = '';
  coolDownTimer!: number | undefined;
  remainingAttempt$ = new BehaviorSubject<number>(REMAINING_ATTEMPT);
  getMfaHttpErrorCode(
    oauthConfig: OauthAEMConfig,
    response: HttpErrorResponse
  ): string {
    return this.getMfaHttpError(oauthConfig, response) ? 'ERROR_MSG_128' : '';
  }

  getMfaHttpError(
    oauthConfig: OauthAEMConfig,
    response: HttpErrorResponse
  ): boolean {
    return (
      (oauthConfig?.EAM_OUTAGE_ERROR_CODE_IGNORE &&
        oauthConfig.EAM_OUTAGE_ERROR_CODE_IGNORE.filter((code) => {
          return response?.status === parseInt(code);
        }).length < 1) ||
      response?.error?.error
    );
  }

  checkResourceNotFoundError(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ): boolean {
    return response?.error?.code === 'RESOURCE_NOT_FOUND' ? true : false;
  }

  checkInvalidActionIdError(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ): boolean {
    return response?.error?.code === 'INVALID_ACTION_ID' ? true : false;
  }

  checkAccessDeniedError(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ): boolean {
    return response?.code === 'access_denied' ? true : false;
  }

  checkFailValidators(response: SubmitNewPassword): boolean | null | undefined {
    return (
      response?.error?.details &&
      response?.error?.details[0]?.code === ACCOUNT_RECOVERY_ERROR &&
      response?.error?.details[0]?.failedValidators &&
      response?.error?.details[0]?.failedValidators.length > 0
    );
  }
}
